import { render } from "./Facility.vue?vue&type=template&id=3cb61cec&scoped=true"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"

import "./Facility.vue?vue&type=style&index=0&id=3cb61cec&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb61cec"]])

export default __exports__